import {use} from 'react';

import {VehicleSeriesDefinitionFormContext} from '../components/FormContext';
import {VehicleSeriesDefinitionContextType} from '../types';

export const useVehicleSeriesDefinitionContext = (): VehicleSeriesDefinitionContextType =>
  use(VehicleSeriesDefinitionFormContext);
